import { render, staticRenderFns } from "./PdfSelector.vue?vue&type=template&id=2572a43d&scoped=true"
import script from "./PdfSelector.vue?vue&type=script&lang=js"
export * from "./PdfSelector.vue?vue&type=script&lang=js"
import "./PdfSelector.vue?vue&type=style&index=0&id=2572a43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572a43d",
  null
  
)

export default component.exports